import { defineComponent as _defineComponent } from 'vue'
import DraggableList from '@/components/DesignStudio/DraggableList.vue';
import CrosswordStyleListItem from './item/CrosswordStyleListItem.vue';
import type { CrosswordStyle } from '../../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'CrosswordStyleList',
  props: {
    items: null,
    disabled: { type: Boolean },
    selectedId: null
  },
  emits: ["select", "edit", "remove", "reorder"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'select', value: CrosswordStyle): void;
    (event: 'edit', value: CrosswordStyle): void;
    (event: 'remove', value: CrosswordStyle): void;
    (event: 'reorder', value: CrosswordStyle[]): void;
}), expose: any, slots: any, attrs: any }) {





const onRowClick = (style: CrosswordStyle) => {
    emit('select', style);
};

return { __sfc: true,emit, onRowClick, DraggableList, CrosswordStyleListItem }
}

})